<template>
  <div>
    <a-row :gutter="20" :class="bem.e('table-row')">
      <a-col :span="22">
        <a-row :gutter="20">
          <a-col
            v-for="(col, index) in props.columns"
            :key="index"
            :span="col.span || 24 / props.columns.length"
            :class="bem.e('table-col')"
          >
            <template v-if="col.key === 'name'">
              <ll-input
                v-model:value="innerData.name"
                :disabled="disabled"
                placeholder="请输入"
              />
            </template>
            <template v-if="col.key === 'required'">
              <ll-button
                type="link"
                :disabled="disabled"
                :class="`${bem.m('required')} ${
                  innerData.required ? bem.is('required') : ''
                }`"
                @click="innerData.required = !innerData.required"
              >
                <ll-icon
                  v-show="innerData.required"
                  icon-name="icon-radio-check"
                />
              </ll-button>
            </template>

            <template v-if="col.key === 'type'">
              <ll-select
                v-model:value="innerData.type"
                :options="paramsOptions"
                :disabled="disabled"
                placeholder="请选择"
                style="width: 100%"
              />
            </template>
            <template v-if="col.key === 'value'">
              <click-input
                v-model:value="innerData.value"
                type="code"
                placeholder="请输入"
                style="width: 100%"
              />
            </template>
            <template v-if="col.key === 'static'">
              <ll-switch
                v-model:checked="innerData[col.key]"
                :disabled="disabled"
              />
            </template>

            <template v-if="col.key === 'description'">
              <ll-input
                v-model:value="innerData[col.key]"
                :placeholder="col.placeholder || '请输入'"
                :disabled="disabled"
              />
            </template>
            <template v-if="col.key === 'contentType'">
              <a-auto-complete
                v-model:value="innerData[col.key]"
                :class="bem.e('auto-complete')"
                :style="{ width: '100%' }"
                :disabled="disabled"
                :options="contentTypeOptions"
                :placeholder="col.placeholder || '请输入'"
              />
            </template>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="2" :class="bem.e('table-col')">
        <a-popconfirm
          title="确定要移除吗？"
          ok-text="确认"
          cancel-text="取消"
          placement="topRight"
          :disabled="disabled"
          :overlay-class-name="bem.e('popconfirm')"
          @confirm="handleDelete(props.dataSource, innerData)"
        >
          <ll-button type="link" :disabled="disabled">
            <ll-icon icon-name="icon-remove" />
          </ll-button>
        </a-popconfirm>
      </a-col>
    </a-row>
  </div>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'
// paramsTableRowEmits
import {
  paramsTableRowProps,
  paramsOptions,
  contentTypeOptions,
} from '../config'

import { createNamespace } from '@ll-plus/utils'

import ClickInput from './click-input.vue'

defineOptions({ name: 'LlParamsTableRow' })

const props = defineProps(paramsTableRowProps)

// const emits = defineEmits(paramsTableRowEmits)

const bem = createNamespace('params-table')

const disabled = inject('disabled')

const innerData = ref(props.data)

const handleDelete = (list, data) => {
  const index = list.findIndex((item) => item.name === data.name)
  list.splice(index, 1)
}
</script>
